import gql from 'graphql-tag'

export const sendSmsMutation = gql`
  mutation sendSms(
    $supporterId: ID!,
    $groupId: ID!,
    $smsBody: String!
  ) {
    sendSms(
      input: {
        supporterId: $supporterId,
        groupId: $groupId,
        smsBody: $smsBody
      }
    ) {
      success
      errors {
        message
        code
      }
    }
  }
` 